import { __assign } from "tslib";
import { KeyboardCode } from '@dnd-kit/core';
var DEFAULT_COORDINATE_MOVEMENT = 25;
export var defaultActivators = [
    {
        eventName: 'onKeyDown',
        handler: function (event, _a) {
            var keyboardCodes = _a.keyboardCodes, onActivation = _a.onActivation;
            var _b = event.nativeEvent, code = _b.code, altKey = _b.altKey, shiftKey = _b.shiftKey;
            // if keyboard codes exist and pressed, activate drag & drop,
            // else Alt + Shift as default keyboard combination for activation
            if ((keyboardCodes === null || keyboardCodes === void 0 ? void 0 : keyboardCodes.activate.includes(code)) ||
                (!keyboardCodes && altKey && shiftKey)) {
                event.preventDefault();
                onActivation === null || onActivation === void 0 ? void 0 : onActivation({ event: event.nativeEvent });
                return true;
            }
            return false;
        },
    },
];
export var defaultKeyboardCoordinateGetter = function (event, _a) {
    var currentCoordinates = _a.currentCoordinates;
    switch (event.code) {
        case KeyboardCode.Right:
            return __assign(__assign({}, currentCoordinates), { x: currentCoordinates.x + DEFAULT_COORDINATE_MOVEMENT });
        case KeyboardCode.Left:
            return __assign(__assign({}, currentCoordinates), { x: currentCoordinates.x - DEFAULT_COORDINATE_MOVEMENT });
        case KeyboardCode.Down:
            return __assign(__assign({}, currentCoordinates), { y: currentCoordinates.y + DEFAULT_COORDINATE_MOVEMENT });
        case KeyboardCode.Up:
            return __assign(__assign({}, currentCoordinates), { y: currentCoordinates.y - DEFAULT_COORDINATE_MOVEMENT });
    }
    return undefined;
};
//# sourceMappingURL=defaults.js.map